var _clipPath, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPropanol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7130"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7128"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L161 0 L161 101 L0 101 L0 0 Z",
    transform: "translate(0, 0)",
    id: "path10494"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M0,3.8L0,3.8L0,3.8L0,3.8L0,3.8z M434,224.2 M0,3.8"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#840000",
      strokeWidth: 1.464,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.450777
    },
    id: "rect262",
    width: 103.02634,
    height: 118.93182,
    x: 1.3825192,
    y: 1.685971,
    ry: 7.1569595
  }), /*#__PURE__*/React.createElement("g", {
    id: "g14136",
    transform: "matrix(0.32471281,0,0,0.32471281,10.661664,50.123277)",
    style: {
      strokeWidth: 5.92831555,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 15,
      fontFamily: "Helvetica",
      stroke: "#000000",
      strokeWidth: 1.99921828,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "g3013",
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-346.97604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line3015",
    d: "M 61.0126,137.5126 83.916534,124.28425",
    style: {
      strokeWidth: 1.99921828,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 15,
      fontFamily: "Helvetica",
      stroke: "#000000",
      strokeWidth: 1.99921828,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "g3017",
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-346.97604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line3019",
    d: "M 83.916534,124.28425 106.82047,137.5126",
    style: {
      strokeWidth: 1.99921828,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fontSize: 15,
      fontFamily: "Helvetica",
      stroke: "#000000",
      strokeWidth: 1.99921828,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    id: "g3021",
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-346.97604)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "line3023",
    d: "M 106.82047,137.5126 122,128.74554",
    style: {
      strokeWidth: 1.99921828,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "text3025",
    style: {
      fontSize: 15,
      fontFamily: "helvetica",
      fill: "#000000",
      strokeLinecap: "round",
      strokeWidth: 1.99921828,
      strokeDasharray: "none"
    },
    transform: "matrix(2.9653168,0,0,2.9653168,-173.81861,-339.70059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3037",
    style: {
      fontFamily: "helvetica",
      fill: "#000000",
      strokeWidth: 1.99921828,
      strokeDasharray: "none"
    },
    d: "m 124.0251,122.05476 c 0,-1.78222 0.47852,-3.17749 1.43555,-4.18579 0.95703,-1.0083 2.19238,-1.51245 3.70605,-1.51246 0.99121,1e-5 1.88476,0.23683 2.68067,0.71045 0.79589,0.47365 1.40257,1.13405 1.82006,1.9812 0.41747,0.84718 0.62621,1.80787 0.62623,2.88208 -2e-5,1.08888 -0.21974,2.063 -0.65918,2.92237 -0.43947,0.85937 -1.06203,1.51001 -1.86768,1.9519 -0.80567,0.4419 -1.67481,0.66284 -2.60742,0.66284 -1.01075,0 -1.91407,-0.24414 -2.70996,-0.73242 -0.7959,-0.48828 -1.39893,-1.15478 -1.80908,-1.99951 -0.41016,-0.84472 -0.61524,-1.73828 -0.61524,-2.68066 z m 1.46484,0.022 c 0,1.29395 0.3479,2.31323 1.04371,3.05786 0.69579,0.74463 1.56859,1.11694 2.6184,1.11694 1.06933,0 1.94946,-0.37597 2.64038,-1.12793 0.69091,-0.75195 1.03637,-1.81884 1.03638,-3.20068 -1e-5,-0.87402 -0.14771,-1.63696 -0.44311,-2.28882 -0.29542,-0.65185 -0.72755,-1.15722 -1.29639,-1.51611 -0.56886,-0.35888 -1.20728,-0.53832 -1.91528,-0.53833 -1.00587,1e-5 -1.87135,0.34547 -2.59644,1.03638 -0.7251,0.69092 -1.08765,1.84448 -1.08765,3.46069 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3039",
    style: {
      fontFamily: "helvetica",
      fill: "#000000",
      strokeWidth: 1.99921828,
      strokeDasharray: "none"
    },
    d: "m 136.16133,127.28425 v -10.73731 h 1.4209 v 4.40918 h 5.58105 v -4.40918 h 1.4209 v 10.73731 h -1.4209 v -5.06104 h -5.58105 v 5.06104 z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropanol);
export default __webpack_public_path__ + "static/media/propanol.b20b677e9e3317a91c3677443fae750d.svg";
export { ForwardRef as ReactComponent };